import React, { useEffect, useMemo, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { CheckCircle2 } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import api from "@/lib/api";

const COLORS = ["#FF6A00", "#FFD500", "#22c55e", "#ffffff", "#FF9A4D"];

export default function SubscriptionCelebration() {
  const { org, refreshOrg } = useAuth();
  const [show, setShow] = useState(false);

  useEffect(() => {
    if (org?.billing?.celebrate_activation) {
      setShow(true);
      api.post("/billing/celebrated").then(({ data }) => { if (data?.org) refreshOrg(data.org); }).catch(() => {});
    }
  }, [org?.billing?.celebrate_activation]); // eslint-disable-line

  const pieces = useMemo(
    () => Array.from({ length: 70 }).map((_, i) => ({
      id: i,
      left: Math.random() * 100,
      delay: Math.random() * 0.7,
      dur: 2.4 + Math.random() * 1.8,
      color: COLORS[i % COLORS.length],
      w: 6 + Math.random() * 8,
      rot: Math.random() * 360,
    })),
    []
  );

  if (!show) return null;

  return (
    <AnimatePresence>
      <motion.div
        data-testid="subscription-celebration"
        className="fixed inset-0 z-[120] flex items-center justify-center bg-black/70 p-4 backdrop-blur-sm"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        exit={{ opacity: 0 }}
      >
        <div className="pointer-events-none absolute inset-0 overflow-hidden">
          {pieces.map((p) => (
            <motion.span
              key={p.id}
              style={{ left: `${p.left}%`, width: p.w, height: p.w * 0.6, background: p.color, borderRadius: 2 }}
              className="absolute top-0"
              initial={{ y: "-10vh", rotate: 0, opacity: 1 }}
              animate={{ y: "110vh", rotate: p.rot + 540, opacity: [1, 1, 0.9, 0] }}
              transition={{ duration: p.dur, delay: p.delay, ease: "easeIn" }}
            />
          ))}
        </div>

        <motion.div
          className="relative mx-auto w-full max-w-sm rounded-3xl border border-zinc-800 bg-zinc-950 p-8 text-center shadow-2xl"
          initial={{ scale: 0.85, y: 24, opacity: 0 }}
          animate={{ scale: 1, y: 0, opacity: 1 }}
          transition={{ type: "spring", stiffness: 220, damping: 20 }}
        >
          <motion.div
            className="mx-auto flex h-20 w-20 items-center justify-center rounded-full bg-[#22c55e]/15"
            initial={{ scale: 0 }}
            animate={{ scale: 1 }}
            transition={{ delay: 0.15, type: "spring", stiffness: 260, damping: 14 }}
          >
            <CheckCircle2 className="h-11 w-11 text-[#22c55e]" strokeWidth={2} />
          </motion.div>
          <h2 className="mt-5 font-display text-2xl font-bold text-white">Abonnement activé 🎉</h2>
          <p className="mt-2 text-sm text-zinc-400">
            Merci ! Votre abonnement HalgarOS est actif. Toutes les fonctionnalités de votre espace sont débloquées.
          </p>
          <button
            data-testid="celebration-close"
            onClick={() => setShow(false)}
            className="mt-6 w-full rounded-full bg-[#FF6A00] py-3 font-semibold text-white transition-colors hover:bg-[#E65F00]"
          >
            C'est parti !
          </button>
        </motion.div>
      </motion.div>
    </AnimatePresence>
  );
}
